import React, { useState, useContext, Fragment } from 'react';
import { orderStatusArray, actionList } from '../../../../../config';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import CustomSkeleton from '../../../../../components/OtherElements/CustomSkeleton';
import { store } from './reducer';
import { useHistory } from 'react-router-dom';
import Map from './Map';
import red from '@material-ui/core/colors/red';
import Typography from '@material-ui/core/Typography';
import { __ } from '../../../../../utils/i18n';
import axios from '../../../../../api/axios';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  map: {
    height: 400,
    border: `1px solid ${theme.palette.primary.light}`,
    marginTop: theme.spacing(1),
    position: 'relative',
  },
  orderStatus: {
    color: red[500],
    textAlign: 'center',
  },
}));

const EditAction = () => {
  const classes = useStyles();
  const history = useHistory();
  const [actionSelected, setActionSelected] = useState(null);
  const {
    state: { order },
    showMessage,
    showError,
    refresh,
  } = useContext(store);
  const [loading, setLoading] = useState(false);
  const handleSelectAction = (e) => {
    const { value } = e.target;
    setActionSelected(value);
  };
  const handleTakeAction = async () => {
    if (actionSelected) {
      if (
        ['movingTowardsOrigin', 'transporting', 'delivered']?.includes(
          actionSelected
        )
      ) {
        try {
          setLoading(true);
          const { data } = await axios.post(
            `/api/v1/admin/orders/changeStatus`,
            {
              orderId: order._id,
              status: actionSelected,
            }
          );
          if (data?.ok) showMessage(data?.messages);
          refresh();
          setActionSelected(null);
        } catch (error) {
          showError(error);
        } finally {
          setLoading(false);
        }
        return;
      }
      history.push(`/protected/admin/orders/${actionSelected}/${order._id}`);
    } else {
      showMessage('یک وضعیت را انتخاب کنید', 2);
    }
  };

  return (
    <Fragment>
      {order ? (
        <Fragment>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography
                variant="h1"
                component="div"
                className={classes.orderStatus}
              >
                {__(order.status)}
              </Typography>
            </Grid>
            <Grid item>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>تغییر وضعیت سفارش</InputLabel>
                <Select
                  value={actionSelected ? actionSelected : ''}
                  onChange={handleSelectAction}
                >
                  {actionList[order.status].map((item) => (
                    <MenuItem key={item} value={item}>
                      {orderStatusArray[item]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                size="medium"
                disabled={!actionSelected || loading}
                endIcon={loading && <CircularProgress size={10} />}
                onClick={handleTakeAction}
              >
                اعمال
              </Button>
            </Grid>
          </Grid>
          <div className={classes.map}>
            <Map order={order} />
          </div>
        </Fragment>
      ) : (
        <CustomSkeleton count={2} height={38} />
      )}
    </Fragment>
  );
};

export default EditAction;
